import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Tag, Typography, Spin, List, Avatar, Form, Input, Button, message, Divider, Popconfirm } from 'antd';
import { CalendarOutlined, UserOutlined, MessageOutlined, EyeOutlined, LikeOutlined, ShareAltOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getPostById, deletePost } from '../../api/localStorage';
import './index.css';

const { Title } = Typography;
const { TextArea } = Input;

const PostDetail = () => {
  const [comments, setComments] = useState([
    {
      id: 1,
      author: '网友A',
      content: '这篇文章写得很好，学到了很多新知识！',
      avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
      datetime: '2025-01-16 10:30'
    },
    {
      id: 2,
      author: '网友B',
      content: '感谢分享，对于React Hooks的理解更加深刻了。',
      avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
      datetime: '2025-01-16 15:45'
    }
  ]);
  
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const post = getPostById(id);

  if (!post) {
    return (
      <div className="post-detail-loading">
        <Spin size="large" tip="文章未找到..." />
      </div>
    );
  }

  const { title, author, date, tags, content } = post;

  const handleSubmit = (values) => {
    setLoading(true);
    
    // 模拟提交评论
    setTimeout(() => {
      const newComment = {
        id: comments.length + 1,
        author: values.author || '匿名用户',
        content: values.content,
        avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
        datetime: new Date().toLocaleString('zh-CN')
      };
      
      setComments([...comments, newComment]);
      form.resetFields();
      setLoading(false);
      message.success('评论发表成功！');
    }, 1000);
  };

  const handleDelete = () => {
    deletePost(id);
    message.success('文章删除成功！');
    navigate('/'); // 删除后跳转到首页
  };

  const handleEdit = () => {
    navigate(`/edit/${id}`); // 跳转到编辑页面
  };

  return (
    <div className="post-detail">
      <Card className="post-detail-card">
        <div className="post-detail-header">
          <Title level={2}>{title}</Title>
          <div className="post-detail-meta">
            <span className="author">
              <UserOutlined /> {author}
            </span>
            <span className="date">
              <CalendarOutlined /> {date}
            </span>
            <span className="views">
              <EyeOutlined /> 128 次浏览
            </span>
          </div>
          <div className="tags">
            {tags.map((tag, index) => (
              <Tag color="blue" key={index}>{tag}</Tag>
            ))}
          </div>
        </div>
        
        <div className="post-detail-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {content}
          </ReactMarkdown>
        </div>
        
        <div className="post-actions">
          <Button icon={<LikeOutlined />}>点赞</Button>
          <Button icon={<ShareAltOutlined />}>分享</Button>
          <Button icon={<EditOutlined />} onClick={handleEdit}>编辑文章</Button>
          <Popconfirm
            title="确认删除"
            description="您确定要删除这篇文章吗？此操作不可撤销。"
            okText="确定"
            cancelText="取消"
            onConfirm={handleDelete}
          >
            <Button danger icon={<DeleteOutlined />}>删除文章</Button>
          </Popconfirm>
        </div>
      </Card>
      
      <Divider />
      
      <Card title="评论" className="comments-section">
        <List
          dataSource={comments}
          renderItem={comment => (
            <List.Item key={comment.id}>
              <List.Item.Meta
                avatar={<Avatar src={comment.avatar} />}
                title={comment.author}
                description={
                  <div>
                    <div>{comment.content}</div>
                    <div style={{ fontSize: '12px', color: '#999', marginTop: '8px' }}>
                      {comment.datetime}
                    </div>
                  </div>
                }
              />
            </List.Item>
          )}
        />
        
        <Divider />
        
        <Form form={form} onFinish={handleSubmit} layout="vertical">
          <Form.Item name="author" label="昵称">
            <Input placeholder="请输入您的昵称" />
          </Form.Item>
          <Form.Item name="content" label="评论">
            <TextArea rows={4} placeholder="请输入您的评论" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading}>
              发表评论
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default PostDetail;